module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis12-e4f431c2294d83bef5979ec2ebe321a6.jpg";